/* tslint:disable */
/* eslint-disable */
/**
 * Account Settings API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { AccessTokenType } from './';
import {
    AccessTokenTypeFromJSON,
    AccessTokenTypeFromJSONTyped,
    AccessTokenTypeToJSON,
} from './';
import type { TokenPermissionResource } from './';
import {
    TokenPermissionResourceFromJSON,
    TokenPermissionResourceFromJSONTyped,
    TokenPermissionResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface AccessTokenGenerationRequest
 */
export interface AccessTokenGenerationRequest {
    /**
     * 
     * @type {string}
     * @memberof AccessTokenGenerationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof AccessTokenGenerationRequest
     */
    note?: string;
    /**
     * 
     * @type {AccessTokenType}
     * @memberof AccessTokenGenerationRequest
     */
    tokenType: AccessTokenType;
    /**
     * 
     * @type {Array<TokenPermissionResource>}
     * @memberof AccessTokenGenerationRequest
     */
    permissions: Array<TokenPermissionResource>;
}

/**
 * Check if a given object implements the AccessTokenGenerationRequest interface.
 */
export function instanceOfAccessTokenGenerationRequest(value: object): value is AccessTokenGenerationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('tokenType' in value) || value['tokenType'] === undefined) return false;
    if (!('permissions' in value) || value['permissions'] === undefined) return false;
    return true;
}

export function AccessTokenGenerationRequestFromJSON(json: any): AccessTokenGenerationRequest {
    return AccessTokenGenerationRequestFromJSONTyped(json, false);
}

export function AccessTokenGenerationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AccessTokenGenerationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'note': json['note'] == null ? undefined : json['note'],
        'tokenType': AccessTokenTypeFromJSON(json['tokenType']),
        'permissions': ((json['permissions'] as Array<any>).map(TokenPermissionResourceFromJSON)),
    };
}

export function AccessTokenGenerationRequestToJSON(value?: AccessTokenGenerationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'note': value['note'],
        'tokenType': AccessTokenTypeToJSON(value['tokenType']),
        'permissions': ((value['permissions'] as Array<any>).map((v) => TokenPermissionResourceToJSON(v))),
    };
}

